export const brookfieldProperties = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 27,
  inputPaddingInline: 20,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 18,
  inputFontFamily: '"Inter", sans-serif',
  inputColor: "#3C4347",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#3C4347",
  inputBorderWidth: 1,
  inputBorderRadius: 3,

  inputHoverColor: "#3C4347",
  inputHoverBorderColor: "#3C4347",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 27,
  selectPaddingInline: 20,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 18,
  selectFontFamily: '"Inter", sans-serif',
  selectColor: "#3C4347",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 400,

  selectBorderColor: "#3C4347",
  selectBorderWidth: 1,
  selectBorderRadius: 3,

  selectHoverColor: "#3C4347",
  selectHoverBorderColor: "#3C4347",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 27,
  textAreaPaddingInline: 20,

  textAreaHeight: 45,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 18,
  textAreaFontFamily: '"Inter", sans-serif',
  textAreaColor: "#3C4347",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#3C4347",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 3,

  textAreaHoverColor: "#3C4347",
  textAreaHoverBorderColor: "#3C4347",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#3C4347",
  placeholderFontFamily: '"Inter", sans-serif',
  placeholderFontSize: 18,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#3C4347",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 18,
  fieldLabelColor: "#3C4347",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#3C4347",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Inter", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#3C4347",
  descriptionFontSize: 18,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Inter", sans-serif',
  descriptionTopSpacing: 12,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#3C4347",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#0F3558",
  checkboxCheckedBorderColor: "#3C4347",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Inter", sans-serif',
  checkboxLabelFontSize: 18,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#3C4347",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#3C4347",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#0F3558",
  radioCheckedBorderColor: "#3C4347",

  radioAlignment: "none",

  radioLabelFontFamily: '"Inter", sans-serif',
  radioLabelFontSize: 18,
  radioLabelFontWeight: 400,
  radioLabelColor: "#3C4347",

  // **********************************
  // submit button

  submitMarginTop: 45,
  submitFontSize: 18,
  submitFontFamily: "'Inter', sans-serif",
  submitWidth: 120,
  submitWidthUnits: "px",
  submitHeight: 45,
  submitBorderRadius: 3,
  submitBorderWidth: 1,
  submitBackground: "#0F3558",
  submitColor: "#fff",
  submitBorderColor: "#0F3558",
  submitBackgroundHover: "#0F3558",
  submitBorderColorHover: "#0F3558",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  